// test706
(706 && 0);
